import {Stack} from '../../layout/stack/stack';
import {Body} from '../../typography/body';

import styles from './matrix-heatmap.module.css';

interface Props {
    columnAxisLabel: string;
    rowPrimaryHeaderLabel: string;
    rowMetricHeaderLabel?: string;
    numColumns: number;
    hasMetric: boolean;
}

export function MatrixHeatmapColumnHeaders(props: Props) {
    return (
        <Stack spacing={8} isHorizontal={true} alignItems='end'>
            <div className={styles['matrix-heatmap-row-label']}>
                <Body size='small' color='medium' isBold={true}>
                    {props.rowPrimaryHeaderLabel}
                </Body>
            </div>
            {props.hasMetric && (
                <div className={styles['matrix-heatmap-metric-header']}>
                    <Body size='small' color='medium' isBold={true}>
                        {props.rowMetricHeaderLabel}
                    </Body>
                </div>
            )}
            <Stack spacing={8} alignItems='center'>
                <Body size='small' color='medium' isBold={true}>
                    {props.columnAxisLabel}
                </Body>
                <Stack spacing={4} isHorizontal={true}>
                    {Array.from({length: props.numColumns}, (_, i) => (
                        <div key={i} className={styles['matrix-heatmap-column-header']}>
                            <Body size='small' color='medium' isBold={true}>
                                {i}
                            </Body>
                        </div>
                    ))}
                </Stack>
            </Stack>
        </Stack>
    );
}
